import React from "react";
import Section from "components/Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "components/SectionHeader";
import useScript from 'hooks/useScript';

function CookiePolicy(props) {
  useScript('https://consent.cookiebot.com/948ac9d8-e3ce-4dde-8d70-5c649d7890e6/cd.js');

  return (
    <Section>
      <Container>
        <SectionHeader
          className="text-center"
          title="Slapukų politika"
          size={1}
          spaced={true}
        />

        <div className="text">
          <h2>Kas yra slapukai?</h2>
          <p>
            Slapukas (angl. Cookie) – tai mažas tekstinis failas, kurį interneto
            svetainė ar mobilioji programėlė įrašo į Jūsų kompiuterio arba
            mobilaus prietaiso naršyklę ar programėlės atmintį, kai Jūs
            apsilankote svetainėje ar naudojatės mobiliąja programėle. Sekantį
            kartą apsilankius svetainėje ar mobiliojoje programėlėje šis failas
            gali būti nuskaitytas, kad svetainė ar mobilioji programėlė galėtų
            atpažinti Jūsų kompiuterį ar mobilųjį prietaisą.
          </p>
          <h2>
            Kaip UAB „Nuomos sistema“ (toliau – Bendrovė) naudoja slapukus?
          </h2>
          <p>
            <a href="/">trymycar.com</a> ir <a href="/">lt.trymycar.com</a> slapukų
            surinkta informacija leidžia mums užtikrinti Jūsų galimybę naršyti
            patogiau, teikti Jums patrauklius pasiūlymus bei daugiau sužinoti
            apie svetainės ar mobiliosios programėlės naudotojų elgesį,
            analizuoti tendencijas ir tobulinti svetainę ar mobiliąją
            programėlę, klientų aptarnavimą ir Bendrovės teikiamas paslaugas.
          </p>
          <p>Bendrovėje slapukai įprastai naudojami šiais tikslais:</p>
          <ul>
            <li>
              Techniniai / būtinieji slapukai: savo lankytojams stengiamės
              pasiūlyti pažangią, paprastą naudoti svetainę / mobiliąją
              programėlę, kuri automatiškai prisitaiko prie jų poreikių ir norų.
              Norėdami tai pasiekti naudojame techninius slapukus, kurie padeda
              rodyti Jums mūsų svetainę, padeda užtikrinti jos funkcionalumą,
              sukurti vartotojo paskyrą, prisijungti ir tvarkyti Jūsų užsakymus.
              Šie techniniai slapukai yra būtini tinkamam mūsų svetainės /
              mobiliosios programėlės funkcionavimui.
            </li>
            <li>
              Analitiniai / statistiniai slapukai: šiuos slapukus naudojame
              įgyti įžvalgų apie tai, kaip mūsų lankytojai naudoja Bendrovės
              svetainę ar mobiliąją programėlę. Tokiu būdu galime optimizuoti ir
              pagerinti savo svetainę / programėlę, suprasti reklamų ir
              komunikacijos efektyvumą bei užtikrinti, kad vis dar esame įdomūs
              ir aktualūs. Galime rinkti duomenis apie Jūsų peržiūrėtus
              internetinius puslapius, iš kurių puslapių atėjote, bei
              informaciją apie datą ir laiką. Tai taip pat reiškia, kad galime
              naudoti informaciją apie Jus ir tai, kaip naudojate Bendrovėje
              svetainę, pavyzdžiui, apsilankymo dažnumą, paspaudimų skaičių tam
              tikrame puslapyje, naudotus paieškos žodžius ir kt. Kaip mūsų
              reklaminių kampanijų dalį, galime panaudoti analitinius slapukus,
              kad sužinotume, kaip vartotojai naršo mūsų svetainėje po to, kai
              jiems parodoma reklama internete. Tai gali apimti ir reklamas
              trečiųjų šalių svetainėse.
            </li>
            <li>
              Funkciniai slapukai: taip pat naudojame funkcinius slapukus
              prisiminti Jūsų pageidavimus ir padėti naudoti mūsų svetainę ir
              mobiliąsias programėles veiksmingai bei efektyviai. Pavyzdžiui,
              šie slapukai prisimena Jūsų pageidaujamą kalbą, paieškas ir
              anksčiau peržiūrėtas prekes. Šiuos slapukus galime naudoti ir Jūsų
              registracijos informacijai prisiminti, kad kaskart apsilankius
              mūsų svetainėje Jums nereikėtų iš naujo įvesti prisijungimo
              duomenų. Šie funkciniai slapukai nėra būtini svetainei
              funkcionuoti, tačiau prideda funkcionalumo ir pagerina Jūsų
              naudojimosi Bendrovės svetaine patirtį.
            </li>
            <li>
              Reklaminiai / trečiųjų šalių slapukai: naudojame savo ir trečiųjų
              šalių slapukus, kad savo bei kitose svetainėse rodytume
              suasmenintą reklamą. Tai vadinama „pakartotine rinkodara“, kuri
              pagrįsta naršymo veiksmais, pavyzdžiui, Jūsų ieškotomis,
              peržiūrėtomis prekėmis.
              <br />
              Slapukai taip pat naudojami tam, kad būtų užregistruota, ar
              sutinkate, kad Bendrovės svetainėje būtų naudojami slapukai, kad
              šis klausimas nebūtų užduodamas kiekvieną kartą apsilankant
              svetainėje.
            </li>
          </ul>
          <p>
            Visus naudojamus slapukus ir jų aprašymus galite matyti slapukų
            išklotinėje.
          </p>
          <h2>Kas yra konversijų sekimas „Pixel“?</h2>
          <p>
            „Pixel“ žyma – tai yra vadinamas (angl. web beacons), (angl. clear
            GIFs) arba paslėptas programinis kodas. „Pixel“ žyma renka
            informaciją su trumpais programinio kodo fragmentais, kurie perkelia
            šią informaciją į mažą grafinį vaizdą (paprastai nematomą) apie Jūsų
            veiksmus, kuriuos atliekate mūsų svetainėje. Surinkta informacija
            persiunčiama į “Pixel” paslaugų tiekėjo serverį, priešingai nei
            slapukai įrašydami į Jūsų naršyklę.
          </p>
          <p>
            „Pixel“ gali rinkti įvairią informacija apie Jūsų veiksmus mūsų
            svetainėje, mygtukų paspaudimus tam tikrose vietose, pildomų formų
            laukų informaciją, IP adresą, informaciją apie naudojamą interneto
            naršyklę ir kt.
          </p>
          <p>
            „Pixel“ žyma taip pat atpažįsta tam tikros rūšies informaciją Jūsų
            kompiuteryje, pvz., esamus slapukus ir juose užfiksuotą informaciją,
            tokiu būdų padeda parinkti Jums reklamas, jas optimizuoti pagal
            surinktus duomenis, kurti tikslines auditorijas būsimoms reklamoms
            ir pakartotinės rinkodaros pasiūlymus potencialiems klientams –
            žmonėms, kurie jau ėmėsi tam tikrų veiksmų mūsų svetainėje.
          </p>
          <h2>Kaip Bendrovė naudoja konversijų sekimą „Pixel“?</h2>
          <p>
            „Pixel“ mes naudojame kaip analizės įrankį, leidžiantį įvertinti
            reklamos efektyvumą, suprasdamas veiksmus, kuriuos atliekate mūsų
            svetainėje. Mums padeda stebėti reklamas, optimizuoti jas pagal
            surinktus duomenis, kurti tikslines auditorijas būsimoms reklamoms
            ir pakartotinės rinkodaros pasiūlymus potencialiems klientams –
            žmonėms, kurie jau ėmėsi tam tikrų veiksmų mūsų svetainėje.
            <br />
            Visus naudojamus „Pixel“ ir jų aprašymus galite matyti slapukų ir
            „Pixel“ išklotinėje.
          </p>
          <h2>Duomenys apie naudojamus slapukus ir „Pixel“:</h2>
          <p>
            Trymycar.com svetainėje (įskaitant lt.trymycar.com ir kitus jos
            sub-domenus) naudojami slapukai. Trymycar.com naudoja slapukus –
            taip pat ir trečiųjų šalių slapukus – rinkti informacijai apie tai,
            kaip lankytojai naudojasi mūsų svetaine. Jie padeda mums kuo geriau
            atsižvelgti į jūsų poreikius, nuolat tobulinti svetainę ir teikti
            pasiūlymus, atitinkančius jūsų interesus.
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
        <div id="script"></div>
      </Container>
    </Section>
  );
}

export default CookiePolicy;
